/**
 * Galaxy atmosphere — renders the #atmo overlay DOM.
 *
 * Called once on app init. Never re-rendered — view transitions only touch #app.
 * CSS: styles/atmosphere.css
 */

/** Render the Galaxy atmosphere overlay HTML. */
export function renderAtmosphere(): string {
  return `<div id="atmo">
  <div class="dust"></div>
  <div class="pillar-glow"></div>
  <div class="pillar1"></div><div class="pillar2"></div><div class="pillar3"></div><div class="pillar4"></div><div class="pillar5"></div>
  <div class="stars"></div>
  <div class="milky"></div>
  <div class="moon"></div>
  <div class="neb1"></div><div class="neb2"></div><div class="neb3"></div><div class="neb4"></div>
  <div class="haze"></div>
  <div class="vignette"></div>
  <div class="fly f1"></div><div class="fly f2"></div>
  <div class="cosmic-drift cd1"></div><div class="cosmic-drift cd2"></div><div class="cosmic-drift cd3"></div><div class="cosmic-drift cd4"></div><div class="cosmic-drift cd5"></div>
  <div class="cosmic-drift cd6"></div><div class="cosmic-drift cd7"></div><div class="cosmic-drift cd8"></div><div class="cosmic-drift cd9"></div><div class="cosmic-drift cd10"></div>
</div>`
}
